import { render, staticRenderFns } from "./CreateReviewPeriod.vue?vue&type=template&id=e9d7f554&scoped=true"
import script from "./CreateReviewPeriod.vue?vue&type=script&lang=js"
export * from "./CreateReviewPeriod.vue?vue&type=script&lang=js"
import style0 from "./CreateReviewPeriod.vue?vue&type=style&index=0&id=e9d7f554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d7f554",
  null
  
)

export default component.exports